var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgets.length)?_c('section',{staticClass:"mr-widget-section",attrs:{"role":"region","aria-label":_vm.__('Merge request reports'),"data-testid":"mr-widget-app"}},_vm._l((_vm.widgets),function(widget,index){return _c(widget,{key:widget.name || index,tag:"component",staticClass:"mr-widget-section",attrs:{"mr":_vm.mr}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }